<template>
    <div class="data-trend-panel">
        <DataPanel :title="title" :reqData="optData" serviceName="queryRobotDataTrend">
            <DataTrendChart class="trend-chart-panel" slot-scope="slotProps" :data="slotProps.data" @trendDataExportHandle="exportHandle" />
        </DataPanel>
    </div>
</template>

<script>
import DataPanel from "@/views/zhiji/components/pagesPanel/DataPanel";
import DataTrendChart from "./DataTrendChart";
import { URLs } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "DataTrendPanel",
    props: ["optData"],
    components: {
        DataPanel,
        DataTrendChart
    },
    computed: {
        title() {
            return this.$t("zhiji.overview.dataTrend");
        },
        reqData() {
            return Object.assign({ type: "robotTrend" }, this.optData);
        }
    },
    methods: {
        exportHandle() {
            let reqUrl = URLs.EXPORT_ROBOT_TREND_DATA + `?date=${this.optData.endTime}`;
            let reqUrlParam = `&language=${this.cvtReqData(this.optData.lang)}&channel=${this.cvtReqData(this.optData.channel)}`;

            reqUrlParam = reqUrlParam.replace(/\s+/g, "");
            reqUrl = reqUrl + reqUrlParam;

            this.zhiji.requestByServiceName("getDownloadToken", reqUrl).then(result => {
                window.open(result, "_blank");
            });
        },
        cvtReqData(data) {
            return data === "all" ? "" : data;
        }
    }
};
</script>
